import { call, put, takeLatest, select } from 'redux-saga/effects';
import ApiRouts from '../../api/routes';
import { GET } from "../../api";
import { FETCH_PRODUCT_LIST, FETCH_SHOW_MORE_PRODUCT_LIST, SET_PRODUCT_LIST } from "../actions";
import { setLoading } from "../slices/loadingSlice";
import { setTotalCount } from "../slices/totalCountSlice";
import { setSelectedId } from '../slices/selectItemDrawerMenu';
import { setShowmoreStatusCode } from '../slices/showmoreStatusCode';


const getSelectedId = (state) => state.selectItemDrawerMenu.selectedId;

const getSelectColorId = (state) => state.selectColor.selectColor

const getSearchInputContent = (state) => state.searchInputContent.searchInputContent;

const getSelectedSpaceId = (state) => state.selectSpace.selectSpace

const getFreeState = (state) => state.freeCheckbox


export function* FetchProductListSaga() {

    const selectedId = yield select(getSelectedId);
    const selectedColorId = yield select(getSelectColorId);
    const selectedSpaceId = yield select(getSelectedSpaceId);
    const searchInputContent = yield select(getSearchInputContent);
    const freeState = yield select(getFreeState);

    try {

        yield put(setLoading(true));

        const url = ApiRouts.API_PRODUCT_LIST({
            free: freeState,
            selectedId,
            selectedColorId,
            selectedSpaceId,
            searchInputContent
        });

        const response = yield call(GET, url, {});


        if (response) {

            yield put({
                type: SET_PRODUCT_LIST,
                payload: response.data.data
            });
            yield put(setTotalCount(response.data.meta.total));
            yield put(setShowmoreStatusCode(response.status));
            yield put(setLoading(false));


        } else {
            throw new Error('Failed to fetch the latest version');
        }

    } catch (error) {
        yield put(setSelectedId(error.response.data.id));
        yield put(setShowmoreStatusCode(error.response.status));
        yield put({ type: FETCH_SHOW_MORE_PRODUCT_LIST });
    }
}

// Watcher Saga
function* productListSaga() {
    yield takeLatest(FETCH_PRODUCT_LIST, FetchProductListSaga);
}

export default productListSaga;
